import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Drawer, Field, Input, Select } from '@itds/elements/index.js';

import Api from '@carrier/utils/Api';

const New = ({ onClose, onSave, show }) => {
  const [errors, setErrors] = useState([]);
  const [data, setData] = useState({
    name: '',
    url: '',
    business_type: 'Comparison Aggregator'
  });

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleSave = () => {
    const errors = [];

    if (!data.name) {
      errors.push('name');
    }

    setErrors(errors);

    if (!errors.length) {
      Api.createVendor(data).then(() => {
        onSave();
      });
    }
  };

  return (
    <Drawer
      alignRight={true}
      footer={<Button onClick={handleSave}>Create New Vendor</Button>}
      onClose={onClose}
      show={show}
      title='New Vendor'
    >
      <Field label='Name'>
        <Input
          invalid={errors.includes('name')}
          onChange={handleInputChange.bind(null, 'name')}
          value={data.name}
        />
      </Field>

      <Field label='Website URL'>
        <Input onChange={handleInputChange.bind(null, 'url')} value={data.url} />
      </Field>

      <Field label='Business Type'>
        <Select
          onChange={handleInputChange.bind(null, 'business_type')}
          options={[
            { value: 'Comparison Aggregator' },
            { value: 'Digital Marketer' },
            { value: 'IMO/BGA' },
            { value: 'Captive Agency' },
            { value: 'Carrier Tool' },
            { value: 'Other' }
          ]}
          value={data.business_type}
        />
      </Field>
    </Drawer>
  );
};

New.propTypes = {
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  show: PropTypes.bool
};

export default New;
